import { NetworkInfo, UnitConfig } from './types';
import BigNumber from 'bignumber.js';

export const NETWORKS: NetworkInfo[] = [
  { 
    name: 'Ethereum', 
    symbol: 'ETH', 
    coingeckoId: 'ethereum'
  },
  { 
    name: 'Binance Smart Chain', 
    symbol: 'BNB', 
    coingeckoId: 'binancecoin',
    unitLabelOverrides: {
      eth: 'BNB',
      gwei: 'gwei',
      wei: 'jager',
      kwei: 'kjager',
      mwei: 'mjager',
      twei: 'tjager',
      pwei: 'pjager'
    }
  },
  { 
    name: 'Avalanche', 
    symbol: 'AVAX', 
    coingeckoId: 'avalanche-2',
    unitLabelOverrides: {
      eth: 'AVAX',
      gwei: 'nAVAX',
      wei: 'wei'
    }
  },
  { 
    name: 'Polygon', 
    symbol: 'MATIC', 
    coingeckoId: 'matic-network',
    unitLabelOverrides: {
      eth: 'MATIC',
      gwei: 'gwei',
      wei: 'wei'
    }
  },
  { 
    name: 'Tron', 
    symbol: 'TRX', 
    coingeckoId: 'tron',
    unitLabelOverrides: {
      eth: 'TRX',
      gwei: 'sun',
      wei: 'sun'
    }
  },
  { 
    name: 'Arbitrum', 
    symbol: 'ARB', 
    coingeckoId: 'arbitrum',
    unitLabelOverrides: {
      eth: 'ARB',
      gwei: 'gwei',
      wei: 'wei'
    }
  }
];

export const UNITS: Record<string, UnitConfig> = {
  eth: {
    label: 'ETH',
    powerNotation: '1,000,000,000,000,000,000 (10^18)',
    conversionFactor: new BigNumber('1000000000000000000'),
    isMainUnit: true,
    showByDefault: true
  },
  gwei: {
    label: 'gwei (Shannon)',
    powerNotation: '1,000,000,000 (10^9)',
    conversionFactor: new BigNumber('1000000000'),
    showByDefault: true
  },
  wei: {
    label: 'wei',
    powerNotation: '1 (10^0)',
    conversionFactor: new BigNumber('1'),
    showByDefault: true
  },
  kwei: {
    label: 'kwei (Babbage)',
    powerNotation: '1,000 (10^3)',
    conversionFactor: new BigNumber('1000'),
    showByDefault: false
  },
  mwei: {
    label: 'mwei (Lovelace)',
    powerNotation: '1,000,000 (10^6)',
    conversionFactor: new BigNumber('1000000'),
    showByDefault: false
  },
  twei: {
    label: 'twei (Szabo)',
    powerNotation: '1,000,000,000,000 (10^12)',
    conversionFactor: new BigNumber('1000000000000'),
    showByDefault: false
  },
  pwei: {
    label: 'pwei (Finney)',
    powerNotation: '1,000,000,000,000,000 (10^15)',
    conversionFactor: new BigNumber('1000000000000000'),
    showByDefault: false
  }
};

export const CONFIG = {
  name: 'Ethereum Unit Converter',
  description: 'Convert between different Ethereum and EVM network denominations',
  networks: NETWORKS,
  units: UNITS,
  defaultNetwork: NETWORKS[0]
}; 